/**
 * @desc 增加企业预约
 * */

import { request } from '../util/request'

/**
 * @name saveCompanyAppointmentInfo
 * @desc 获取保险产品列表
 * @params {object} data
 * @param {string} data.companyName 企业名称
 * @param {string} data.companyContact 联系人
 * @param {object} data.contactMobile 联系电话
 * @param {boolean} data.referrer 推荐人
 * */
export function saveCompanyAppointmentInfo (data = {}, loadingConfig) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/companyInfoResource/saveCompanyInfo`,
    method: 'POST',
    data,
    loadingConfig
  })
}

export function homepageresources (params = {}, loadingConfig) {
  return request({
    url: `https://hmb.baoxian72.com/hmbmall-online-web/api/goods/test/detail.shtml?code=${process.env.VUE_APP_BAOSICODE}`,
    method: 'GET',
    params,
    loadingConfig
  })
}

export function axiosclause (params = {}, loadingConfig) {
  return request({
    url: `https://hmb.baoxian72.com/hmbmall-online-web/api/goods/clause/detail.shtml`,
    method: 'GET',
    params,
    loadingConfig
  })
}